import { Link, useRouteError } from "react-router-dom";

export function NotFound() {
  const err = useRouteError();
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">Nicht gefunden</h1>
      <p className="text-sm text-fg-muted">
        Diese Seite gibt es nicht. {err ? <span>({String(err)})</span> : null}
      </p>
      <Link
        to="/"
        className="inline-flex w-fit items-center gap-2 rounded-input bg-accent px-5 py-3 text-sm font-medium text-accent-fg transition hover:opacity-90"
      >
        ← Zurück zum Start
      </Link>
    </div>
  );
}
